var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFreeAccessIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 41,
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.84793 7.95385C1.84793 3.86956 5.1589 0.558594 9.24319 0.558594L25.0919 0.558594C29.1762 0.558594 32.4872 3.86957 32.4872 7.95386L32.4872 30.9983C32.4871 35.0826 29.1762 38.3935 25.0919 38.3935L9.24318 38.3935C5.15888 38.3935 1.8479 35.0826 1.84791 30.9983L1.84793 7.95385Z",
  fill: "url(#paint0_linear_5094_23850)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.47068 15.4422C9.47068 16.1848 8.86869 16.7868 8.12609 16.7868C7.38349 16.7868 6.78149 16.1848 6.78149 15.4422C6.78149 14.6997 7.38349 14.0977 8.12609 14.0977C8.86869 14.0977 9.47068 14.6997 9.47068 15.4422ZM11.3315 15.4423C11.3315 14.8854 11.783 14.4339 12.34 14.4339H23.769C24.326 14.4339 24.7775 14.8854 24.7775 15.4423C24.7775 15.9993 24.326 16.4508 23.769 16.4508H12.34C11.783 16.4508 11.3315 15.9993 11.3315 15.4423ZM8.12612 20.8194C8.86871 20.8194 9.47071 20.2174 9.47071 19.4748C9.47071 18.7322 8.86871 18.1303 8.12612 18.1303C7.38352 18.1303 6.78152 18.7322 6.78152 19.4748C6.78152 20.2174 7.38352 20.8194 8.12612 20.8194ZM12.4269 18.4664C11.87 18.4664 11.4185 18.9179 11.4185 19.4748C11.4185 20.0318 11.87 20.4833 12.4269 20.4833H23.856C24.4129 20.4833 24.8644 20.0318 24.8644 19.4748C24.8644 18.9179 24.4129 18.4664 23.856 18.4664H12.4269ZM8.12612 24.8557C8.86871 24.8557 9.47071 24.2538 9.47071 23.5112C9.47071 22.7686 8.86871 22.1666 8.12612 22.1666C7.38352 22.1666 6.78152 22.7686 6.78152 23.5112C6.78152 24.2538 7.38352 24.8557 8.12612 24.8557ZM12.34 22.5027C11.783 22.5027 11.3315 22.9542 11.3315 23.5112C11.3315 24.0681 11.783 24.5196 12.34 24.5196H17.7184C18.2753 24.5196 18.7268 24.0681 18.7268 23.5112C18.7268 22.9542 18.2753 22.5027 17.7184 22.5027H12.34Z",
  fill: "#1A2B7B"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_5094_23850)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.152 32.1537C38.152 36.7949 34.3896 40.5574 29.7483 40.5574C25.1071 40.5574 21.3446 36.7949 21.3446 32.1537C21.3446 27.5125 25.1071 23.75 29.7483 23.75C34.3896 23.75 38.152 27.5125 38.152 32.1537Z",
  fill: "#49EC60",
  fillOpacity: 0.8
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9057 29.4766L28.5535 34.8287L25.5911 31.864",
  stroke: "#1A2B7B",
  strokeWidth: 2.68919,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_5094_23850",
  x: 20,
  y: 22.4054,
  width: 19.4966,
  height: 19.4978,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 0.672297
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_5094_23850"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_5094_23850",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5094_23850",
  x1: 1.8479,
  y1: 38.3936,
  x2: 39.9562,
  y2: 27.9024,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00139492,
  stopColor: "#7389FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CC80E5"
})))));
export default SvgFreeAccessIllustration;